import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ModalContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  maxWidth: "320px",
  gap: "25px",
}));

export const SuccessImage = styled("img")(({ theme }) => ({
  maxWidth: "80px"
}));